import "./navbar.css";

const Navbar = ({ onNavButtonClick }) => {
  // Receive function as prop
  return (
    <div className="navbar">
      <div className="navContainer">
        <div className="leftPanel"></div>
        <div className="centrePanel">
          <span
            className="navAllButton"
            onClick={() => onNavButtonClick("navAllButton")}
          >
            All
          </span>
          <span
            className="navHotButton"
            onClick={() => onNavButtonClick("navHotButton")}
          >
            Hot
          </span>
          <span
            className="navFreeButton"
            onClick={() => onNavButtonClick("navFreeButton")}
          >
            Free
          </span>
        </div>
        <div className="rightPanel"> .</div>
      </div>
    </div>
  );
};

export default Navbar;
